export const groupIndices = {
  CoreBooster: [
    {
      index: "knowledgecenter",
      alias: "Knowledge Center",
      abbr: "KC",
      type: "default",
      disabled: false,
    },
    {
      index: "provider-experience",
      alias: "Provider Experience",
      abbr: "PE",
      type: "default",
      disabled: false,
    },
    {
      index: "incubation",
      alias: "Incubation",
      abbr: "In",
      type: "default",
      disabled: false,
    },
    {
      index: "shamrocks",
      alias: "Shamrocks",
      abbr: "SR",
      type: "default",
      disabled: false,
    },
    {
      index: "optum-guide",
      alias: "Optum Guide",
      abbr: "OG",
      type: "default",
      disabled: false,
    },
    {
      index: "uhci",
      alias: "UHCI",
      abbr: "UHCI",
      type: "default",
      disabled: false,
    },
    {
      index: "provider-contracts",
      alias: "Provider Contracts",
      abbr: "PC",
      type: "default",
      disabled: false,
    },
    {
      index: "oap",
      alias: "OAP",
      abbr: "OAP",
      type: "default",
      disabled: false,
    },
    {
      index: "oap-gitz",
      alias: "OAP GITZ",
      abbr: "OAP GITZ",
      type: "default",
      disabled: false,
    },
    {
      index: "oap-umr",
      alias: "OAP UMR",
      abbr: "OAP UMR",
      type: "default",
      disabled: false,
    },
    {
      index: "oap-umr-isg",
      alias: "OAP UMR ISG",
      abbr: "OAP UMR ISG",
      type: "default",
      disabled: false,
    },
    {
      index: "oap-umr-general",
      alias: "OAP UMR GENERAL",
      abbr: "OAP UMR GENERAL",
      type: "default",
      disabled: false,
    },
    {
      index: "provider-demographic",
      alias: "Provider Demographic",
      abbr: "PDemo",
      type: "default",
      disabled: false,
    },
    {
      index: "bar",
      alias: "BAR",
      abbr: "BAR",
      type: "default",
      disabled: false,
    },
    {
      index: "pic-leaders",
      alias: "PIC Leaders",
      abbr: "PIC Leaders",
      type: "excel",
      disabled: false,
    },
    {
      index: "mris",
      alias: "MRIS",
      abbr: "MRIS",
      type: "default",
      disabled: false,
    },
    {
      index: "contract-compare",
      alias: "Contract Compare",
      abbr: "CC",
      type: "excel",
      disabled: false,
    },
    {
      index: "p360",
      alias: "P360",
      abbr: "P360",
      type: "default",
      disabled: false,
    },
    {
      index: "cns-k-chatbot",
      alias: "CnS K Chatbot",
      abbr: "CnS",
      type: "default",
      disabled: false,
    },
  ],
  pdpservices: [
    {
      index: "shamrocks",
      alias: "Shamrocks",
      abbr: "SR",
      type: "default",
      disabled: false,
    },
  ],
  uhci_analytics: [
    {
      index: "uhci",
      alias: "UHCI",
      abbr: "UHCI",
      type: "default",
      disabled: false,
    },
  ],
  OptumGuide: [
    {
      index: "optum-guide",
      alias: "Optum Guide",
      abbr: "OG",
      type: "default",
      disabled: false,
    },
  ],
  ProviderContracts: [
    {
      index: "provider-contracts",
      alias: "Provider Contracts",
      abbr: "PC",
      type: "default",
      disabled: false,
    },
  ],
  OAP: [
    {
      index: "oap",
      alias: "OAP",
      abbr: "OAP",
      type: "default",
      disabled: false,
    },
  ],
  OAP_GITZ: [
    {
      index: "oap-gitz",
      alias: "OAP-GITZ",
      abbr: "OAP-GITZ",
      type: "default",
      disabled: false,
    },
  ],
  OAP_UMR: [
    {
      index: "oap-umr",
      alias: "OAP UMR",
      abbr: "OAP UMR",
      type: "default",
      disabled: false,
    },
  ],
  provider_demographic_bot: [
    {
      index: "provider-demographic",
      alias: "Provider Demographic",
      abbr: "PDemo",
      type: "default",
      disabled: false,
    },
  ],
  BAR: [
    {
      index: "bar",
      alias: "BAR",
      abbr: "BAR",
      type: "default",
      disabled: false,
    },
  ],
  PIC_Leaders_BOT: [
    {
      index: "pic-leaders",
      alias: "PIC Leaders",
      abbr: "PIC Leaders",
      type: "excel",
      disabled: false,
    },
  ],
  MRIS_BOT: [
    {
      index: "mris",
      alias: "MRIS",
      abbr: "MRIS",
      type: "default",
      disabled: false,
    },
  ],
  Contract_Compare_BOT: [
    {
      index: "contract-compare",
      alias: "Contract Compare",
      abbr: "CC",
      type: "excel",
      disabled: false,
    },
  ],
  OAP_UMR_ISG_BOT: [
    {
      index: "oap-umr-isg",
      alias: "OAP UMR ISG",
      abbr: "OAP UMR ISG",
      type: "default",
      disabled: false,
    },
  ],
  OAP_UMR_GENERAL_BOT: [
    {
      index: "oap-umr-general",
      alias: "OAP UMR GENERAL",
      abbr: "OAP UMR GENERAL",
      type: "default",
      disabled: false,
    },
  ],
  P360_BOT: [
    {
      index: "p360",
      alias: "P360",
      abbr: "P360",
      type: "default",
      disabled: false,
    },
  ],
  CnS_K_Chatbot: [
    {
      index: "cns-k-chatbot",
      alias: "CnS K Chatbot",
      abbr: "CnS",
      type: "default",
      disabled: false,
    },
  ],
  default: [
    {
      index: "knowledgecenter",
      alias: "Knowledge Center",
      abbr: "KC",
      type: "default",
      disabled: false,
    },
  ],
};
